/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CopropertyDto,
  CopropertyEligibilityDto,
  CopropertyOperationResponse,
  CopropertyQuestionnaireResponse,
  CreateCopropertyCommand,
  GetCopropertyByContractResponse,
  LinkCopropertyToRiskRequest,
  SaveCopropertyQuestionnaireRequest,
  TerrainEstimationDto,
  UpdateCopropertyBuildingsCommand,
  UpdateCopropertyClaimsHistoryCommand,
  UpdateCopropertyCommand,
  UpdateCopropertyComplementsCommand,
  UpdateCopropertyResponse,
} from '../models/index';
import {
    CopropertyDtoFromJSON,
    CopropertyDtoToJSON,
    CopropertyEligibilityDtoFromJSON,
    CopropertyEligibilityDtoToJSON,
    CopropertyOperationResponseFromJSON,
    CopropertyOperationResponseToJSON,
    CopropertyQuestionnaireResponseFromJSON,
    CopropertyQuestionnaireResponseToJSON,
    CreateCopropertyCommandFromJSON,
    CreateCopropertyCommandToJSON,
    GetCopropertyByContractResponseFromJSON,
    GetCopropertyByContractResponseToJSON,
    LinkCopropertyToRiskRequestFromJSON,
    LinkCopropertyToRiskRequestToJSON,
    SaveCopropertyQuestionnaireRequestFromJSON,
    SaveCopropertyQuestionnaireRequestToJSON,
    TerrainEstimationDtoFromJSON,
    TerrainEstimationDtoToJSON,
    UpdateCopropertyBuildingsCommandFromJSON,
    UpdateCopropertyBuildingsCommandToJSON,
    UpdateCopropertyClaimsHistoryCommandFromJSON,
    UpdateCopropertyClaimsHistoryCommandToJSON,
    UpdateCopropertyCommandFromJSON,
    UpdateCopropertyCommandToJSON,
    UpdateCopropertyComplementsCommandFromJSON,
    UpdateCopropertyComplementsCommandToJSON,
    UpdateCopropertyResponseFromJSON,
    UpdateCopropertyResponseToJSON,
} from '../models/index';

export interface CreateCopropertyRequest {
    createCopropertyCommand: CreateCopropertyCommand;
}

export interface GetCopropertyRequest {
    copropertyId: string;
}

export interface GetCopropertyByContractIdRequest {
    contractId: string;
}

export interface GetCopropertyEligibilityRequest {
    copropertyId: string;
}

export interface GetCopropertyTerrainEstimationRequest {
    copropertyId: string;
}

export interface LinkCopropertyToRiskOperationRequest {
    linkCopropertyToRiskRequest: LinkCopropertyToRiskRequest;
}

export interface SaveCopropertyQuestionnaireOperationRequest {
    copropertyId: string;
    saveCopropertyQuestionnaireRequest: SaveCopropertyQuestionnaireRequest;
}

export interface UpdateCopropertyRequest {
    copropertyId: string;
    updateCopropertyCommand: UpdateCopropertyCommand;
}

export interface UpdateCopropertyBuildingsRequest {
    copropertyId: string;
    updateCopropertyBuildingsCommand: UpdateCopropertyBuildingsCommand;
}

export interface UpdateCopropertyClaimsHistoryRequest {
    copropertyId: string;
    updateCopropertyClaimsHistoryCommand: UpdateCopropertyClaimsHistoryCommand;
}

export interface UpdateCopropertyComplementsRequest {
    copropertyId: string;
    updateCopropertyComplementsCommand: UpdateCopropertyComplementsCommand;
}

/**
 * 
 */
export class CopropertiesApi extends runtime.BaseAPI {

    /**
     * Create a coproperty (address + identity), owned by the connected broker
     */
    async createCopropertyRaw(requestParameters: CreateCopropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopropertyOperationResponse>> {
        if (requestParameters['createCopropertyCommand'] == null) {
            throw new runtime.RequiredError(
                'createCopropertyCommand',
                'Required parameter "createCopropertyCommand" was null or undefined when calling createCoproperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/coproprietes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCopropertyCommandToJSON(requestParameters['createCopropertyCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopropertyOperationResponseFromJSON(jsonValue));
    }

    /**
     * Create a coproperty (address + identity), owned by the connected broker
     */
    async createCoproperty(requestParameters: CreateCopropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopropertyOperationResponse> {
        const response = await this.createCopropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Coproperty with address and buildings
     */
    async getCopropertyRaw(requestParameters: GetCopropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopropertyDto>> {
        if (requestParameters['copropertyId'] == null) {
            throw new runtime.RequiredError(
                'copropertyId',
                'Required parameter "copropertyId" was null or undefined when calling getCoproperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/coproprietes/{copropertyId}`.replace(`{${"copropertyId"}}`, encodeURIComponent(String(requestParameters['copropertyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopropertyDtoFromJSON(jsonValue));
    }

    /**
     * Coproperty with address and buildings
     */
    async getCoproperty(requestParameters: GetCopropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopropertyDto> {
        const response = await this.getCopropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Coproperty covered by an MRI contract, with the COPRO_MRI survey answers (contract \"Coproperty\" tab)
     */
    async getCopropertyByContractIdRaw(requestParameters: GetCopropertyByContractIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCopropertyByContractResponse>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getCopropertyByContractId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/coproprietes/contrats/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCopropertyByContractResponseFromJSON(jsonValue));
    }

    /**
     * Coproperty covered by an MRI contract, with the COPRO_MRI survey answers (contract \"Coproperty\" tab)
     */
    async getCopropertyByContractId(requestParameters: GetCopropertyByContractIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCopropertyByContractResponse> {
        const response = await this.getCopropertyByContractIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Global MRI eligibility verdict (coproperty and buildings together), for the eligibility summary
     */
    async getCopropertyEligibilityRaw(requestParameters: GetCopropertyEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopropertyEligibilityDto>> {
        if (requestParameters['copropertyId'] == null) {
            throw new runtime.RequiredError(
                'copropertyId',
                'Required parameter "copropertyId" was null or undefined when calling getCopropertyEligibility().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/coproprietes/{copropertyId}/eligibilite`.replace(`{${"copropertyId"}}`, encodeURIComponent(String(requestParameters['copropertyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopropertyEligibilityDtoFromJSON(jsonValue));
    }

    /**
     * Global MRI eligibility verdict (coproperty and buildings together), for the eligibility summary
     */
    async getCopropertyEligibility(requestParameters: GetCopropertyEligibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopropertyEligibilityDto> {
        const response = await this.getCopropertyEligibilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Best-effort terrain estimation from the coproperty point — altitude (Google Elevation), cadastral parcel (IGN), building footprint (BD TOPO), green space = parcel − footprint
     */
    async getCopropertyTerrainEstimationRaw(requestParameters: GetCopropertyTerrainEstimationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerrainEstimationDto>> {
        if (requestParameters['copropertyId'] == null) {
            throw new runtime.RequiredError(
                'copropertyId',
                'Required parameter "copropertyId" was null or undefined when calling getCopropertyTerrainEstimation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/coproprietes/{copropertyId}/estimation-terrain`.replace(`{${"copropertyId"}}`, encodeURIComponent(String(requestParameters['copropertyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerrainEstimationDtoFromJSON(jsonValue));
    }

    /**
     * Best-effort terrain estimation from the coproperty point — altitude (Google Elevation), cadastral parcel (IGN), building footprint (BD TOPO), green space = parcel − footprint
     */
    async getCopropertyTerrainEstimation(requestParameters: GetCopropertyTerrainEstimationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerrainEstimationDto> {
        const response = await this.getCopropertyTerrainEstimationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Attach a broker-owned coproperty to an MRI risk (completes the COPROPERTY_REGISTRATION sub-step)
     */
    async linkCopropertyToRiskRaw(requestParameters: LinkCopropertyToRiskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopropertyOperationResponse>> {
        if (requestParameters['linkCopropertyToRiskRequest'] == null) {
            throw new runtime.RequiredError(
                'linkCopropertyToRiskRequest',
                'Required parameter "linkCopropertyToRiskRequest" was null or undefined when calling linkCopropertyToRisk().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/risques/copropriete`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LinkCopropertyToRiskRequestToJSON(requestParameters['linkCopropertyToRiskRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopropertyOperationResponseFromJSON(jsonValue));
    }

    /**
     * Attach a broker-owned coproperty to an MRI risk (completes the COPROPERTY_REGISTRATION sub-step)
     */
    async linkCopropertyToRisk(requestParameters: LinkCopropertyToRiskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopropertyOperationResponse> {
        const response = await this.linkCopropertyToRiskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save the COPRO_MRI questionnaire answers and evaluate the environment kill questions
     */
    async saveCopropertyQuestionnaireRaw(requestParameters: SaveCopropertyQuestionnaireOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopropertyQuestionnaireResponse>> {
        if (requestParameters['copropertyId'] == null) {
            throw new runtime.RequiredError(
                'copropertyId',
                'Required parameter "copropertyId" was null or undefined when calling saveCopropertyQuestionnaire().'
            );
        }

        if (requestParameters['saveCopropertyQuestionnaireRequest'] == null) {
            throw new runtime.RequiredError(
                'saveCopropertyQuestionnaireRequest',
                'Required parameter "saveCopropertyQuestionnaireRequest" was null or undefined when calling saveCopropertyQuestionnaire().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/coproprietes/{copropertyId}/questionnaire`.replace(`{${"copropertyId"}}`, encodeURIComponent(String(requestParameters['copropertyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveCopropertyQuestionnaireRequestToJSON(requestParameters['saveCopropertyQuestionnaireRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopropertyQuestionnaireResponseFromJSON(jsonValue));
    }

    /**
     * Save the COPRO_MRI questionnaire answers and evaluate the environment kill questions
     */
    async saveCopropertyQuestionnaire(requestParameters: SaveCopropertyQuestionnaireOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopropertyQuestionnaireResponse> {
        const response = await this.saveCopropertyQuestionnaireRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update identity, structural attributes and natures (coproperty sub-step); returns the sub-step verdict (terrain, altitude)
     */
    async updateCopropertyRaw(requestParameters: UpdateCopropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCopropertyResponse>> {
        if (requestParameters['copropertyId'] == null) {
            throw new runtime.RequiredError(
                'copropertyId',
                'Required parameter "copropertyId" was null or undefined when calling updateCoproperty().'
            );
        }

        if (requestParameters['updateCopropertyCommand'] == null) {
            throw new runtime.RequiredError(
                'updateCopropertyCommand',
                'Required parameter "updateCopropertyCommand" was null or undefined when calling updateCoproperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/coproprietes/{copropertyId}`.replace(`{${"copropertyId"}}`, encodeURIComponent(String(requestParameters['copropertyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCopropertyCommandToJSON(requestParameters['updateCopropertyCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCopropertyResponseFromJSON(jsonValue));
    }

    /**
     * Update identity, structural attributes and natures (coproperty sub-step); returns the sub-step verdict (terrain, altitude)
     */
    async updateCoproperty(requestParameters: UpdateCopropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCopropertyResponse> {
        const response = await this.updateCopropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace the building list (reconciled by id — buildings sub-step); returns the sub-step verdict
     */
    async updateCopropertyBuildingsRaw(requestParameters: UpdateCopropertyBuildingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCopropertyResponse>> {
        if (requestParameters['copropertyId'] == null) {
            throw new runtime.RequiredError(
                'copropertyId',
                'Required parameter "copropertyId" was null or undefined when calling updateCopropertyBuildings().'
            );
        }

        if (requestParameters['updateCopropertyBuildingsCommand'] == null) {
            throw new runtime.RequiredError(
                'updateCopropertyBuildingsCommand',
                'Required parameter "updateCopropertyBuildingsCommand" was null or undefined when calling updateCopropertyBuildings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/coproprietes/{copropertyId}/batiments`.replace(`{${"copropertyId"}}`, encodeURIComponent(String(requestParameters['copropertyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCopropertyBuildingsCommandToJSON(requestParameters['updateCopropertyBuildingsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCopropertyResponseFromJSON(jsonValue));
    }

    /**
     * Replace the building list (reconciled by id — buildings sub-step); returns the sub-step verdict
     */
    async updateCopropertyBuildings(requestParameters: UpdateCopropertyBuildingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCopropertyResponse> {
        const response = await this.updateCopropertyBuildingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace the declarative claims history (period and one line per affected guarantee, reconciled by id), the insurance history of the last 36 months and the mutual recourse waiver; returns the global verdict
     */
    async updateCopropertyClaimsHistoryRaw(requestParameters: UpdateCopropertyClaimsHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCopropertyResponse>> {
        if (requestParameters['copropertyId'] == null) {
            throw new runtime.RequiredError(
                'copropertyId',
                'Required parameter "copropertyId" was null or undefined when calling updateCopropertyClaimsHistory().'
            );
        }

        if (requestParameters['updateCopropertyClaimsHistoryCommand'] == null) {
            throw new runtime.RequiredError(
                'updateCopropertyClaimsHistoryCommand',
                'Required parameter "updateCopropertyClaimsHistoryCommand" was null or undefined when calling updateCopropertyClaimsHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/coproprietes/{copropertyId}/sinistralite`.replace(`{${"copropertyId"}}`, encodeURIComponent(String(requestParameters['copropertyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCopropertyClaimsHistoryCommandToJSON(requestParameters['updateCopropertyClaimsHistoryCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCopropertyResponseFromJSON(jsonValue));
    }

    /**
     * Replace the declarative claims history (period and one line per affected guarantee, reconciled by id), the insurance history of the last 36 months and the mutual recourse waiver; returns the global verdict
     */
    async updateCopropertyClaimsHistory(requestParameters: UpdateCopropertyClaimsHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCopropertyResponse> {
        const response = await this.updateCopropertyClaimsHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the complements (current contract, next general meeting) — passable sub-step, never blocking; the insurance history moved to the claims step
     */
    async updateCopropertyComplementsRaw(requestParameters: UpdateCopropertyComplementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CopropertyOperationResponse>> {
        if (requestParameters['copropertyId'] == null) {
            throw new runtime.RequiredError(
                'copropertyId',
                'Required parameter "copropertyId" was null or undefined when calling updateCopropertyComplements().'
            );
        }

        if (requestParameters['updateCopropertyComplementsCommand'] == null) {
            throw new runtime.RequiredError(
                'updateCopropertyComplementsCommand',
                'Required parameter "updateCopropertyComplementsCommand" was null or undefined when calling updateCopropertyComplements().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/coproprietes/{copropertyId}/complements`.replace(`{${"copropertyId"}}`, encodeURIComponent(String(requestParameters['copropertyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCopropertyComplementsCommandToJSON(requestParameters['updateCopropertyComplementsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CopropertyOperationResponseFromJSON(jsonValue));
    }

    /**
     * Update the complements (current contract, next general meeting) — passable sub-step, never blocking; the insurance history moved to the claims step
     */
    async updateCopropertyComplements(requestParameters: UpdateCopropertyComplementsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CopropertyOperationResponse> {
        const response = await this.updateCopropertyComplementsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
